import React from 'react'

type LogoMonogramProps = {
  color?: string
} & React.SVGProps<SVGSVGElement>

export function LogoMonogram({
  color = 'currentColor',
  ...restProps
}: LogoMonogramProps) {
  return (
    <svg
      height='2em'
      viewBox='0 0 44 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...restProps}
    >
      <path
        d='M21.8103 13.6346L18.0596 0.672119H7.65234V2.75299H8.64066C9.87243 2.75299 10.8929 3.47034 11.2675 4.79764L16.9993 24.5523H22.2211L24.7801 15.7832L24.7439 15.7513C23.0739 15.7512 22.253 15.1372 21.8103 13.6346Z'
        fill={color}
      />
      <path
        d='M42.8612 22.4702C41.6335 22.4702 40.6449 21.6532 40.2702 20.3897L34.5385 0.670898H26.5547L33.4781 24.5511H43.8495V22.4702H42.8612Z'
        fill={color}
      />
      <path
        d='M0.34375 22.4657V24.5542H9.56716V24.5502V22.4697V22.4657H0.34375Z'
        fill={color}
      />
    </svg>
  )
}
